// extracted by mini-css-extract-plugin
export default {"cls1":"kQP_yTnWbxpxc4fPOj4S","cls2":"tHrFXnTYmhvDqzrzAvZK kQP_yTnWbxpxc4fPOj4S"};